import { AuthCheck } from './AuthCheck';
import { Archive } from './pages/Archive';
import { Dashboard } from './pages/Dashboard';
import { Invite } from './pages/Invite';
import { ResetPassword } from './pages/ResetPassword';
import { routes } from './routes';
import { Redirect, Route, Switch, Router as Wouter } from 'wouter';

export const AuthenticatedRouter = () => {
  return (
    <Wouter>
      <AuthCheck>
        <Switch>
          <Route path={routes.resetPassword}>
            <ResetPassword />
          </Route>
          <Route path={routes.invite}>
            <Invite />
          </Route>
          <Route path={routes.archive}>
            <Archive />
          </Route>
          <Route path={routes.home}>
            <Dashboard />
          </Route>
          <Route>
            <Redirect
              replace
              to={routes.home}
            />
          </Route>
        </Switch>
      </AuthCheck>
    </Wouter>
  );
};
